import {HeaderConfigType, GetConfigParams} from './types';
import getArhiConfig from './arhi';

const PHONE_NUMBER = '1300 853 530';

const getProvidersConfig = (config: GetConfigParams): HeaderConfigType => {
  const arhiConfig = getArhiConfig(config);
  return {
    ...arhiConfig,
    id: 'header-providers',
    phoneNumber: PHONE_NUMBER,
    smallHeaderConfig: {
      ...arhiConfig.smallHeaderConfig,
      id: 'small-header-providers',
      phoneNumber: PHONE_NUMBER
    }
  };
};

export default getProvidersConfig;
